import JSONBig from 'json-bigint'

// 装修嵌套 JSON 中的长整数必须在解析阶段保留为字符串，不能先转 Number 再补救。
const losslessJson = JSONBig({ storeAsString: true })

/** 读取装修模块数组，保留分组、商品、页面链接等长 ID 的原始精度。 */
export function parseDecorPageData(pageData) {
  const modules = losslessJson.parse(pageData)
  if (!Array.isArray(modules)) throw new Error('装修页面数据必须是模块数组')
  return modules
}
